module.exports = __webpack_public_path__ + "static/media/b-3.380fcf55.jpg";